"use strict";

(function (angular) {
  'use strict';

  function setEnv() {
    var hostname = window && window.location && window.location.hostname;

    if (hostname === 'app.livestay.com') {
      window.ENVIRONMENT = 'production';
    } else if (hostname === 'stage-app.livestay.com') {
      window.ENVIRONMENT = 'stage';
    } else if (/^qa/.test(hostname)) {
      window.ENVIRONMENT = 'qa';
    } else if (/^dev/.test(hostname)) {
      window.ENVIRONMENT = 'development';
    } else {
      window.ENVIRONMENT = 'local';
    }
  }
  /********** App Component Controller **********/


  function AppCtrl($window, $state, AuthService, LoginService, TripService, MessageController, AUTH_EVENTS) {
    var vm = this;
    vm.user = AuthService.getUser;
    vm.isLoggedIn = AuthService.isLoggedIn;

    vm.logout = function () {
      LoginService.logout().then(function () {
        $state.go('login');
        $window.location.reload();
      })["catch"](function () {
        AuthService.logout();
        $state.go('login');
        $window.location.reload();
      });
    };

    vm.navItems = [{
      name: 'Home',
      state: 'dashboard',
      icon: 'fa fa-home'
    }, {
      name: 'My Trips',
      state: 'trips.list',
      icon: 'fa fa--45 fa-plane'
    }, {
      name: 'My Account',
      state: 'account.profile',
      icon: 'fa fa-user'
    }];
  }

  AppCtrl.$inject = ['$window', '$state', 'AuthService', 'LoginService', 'TripService', 'MessageController', 'AUTH_EVENTS'];
  /********** App Config **********/

  function AppConfig($httpProvider, $locationProvider, localStorageServiceProvider) {
    localStorageServiceProvider.setPrefix('ls').setStorageType('localStorage');
    setEnv();

    if (window.ENVIRONMENT === 'production') {
      var script = document.createElement('script');
      script.innerHTML = "\n      (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){\n            (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n          m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');\n  \n        ga('create', 'UA-3434724-18', 'auto');\n      ";
      document.head.appendChild(script);
    }

    $locationProvider.hashPrefix('');
    $httpProvider.interceptors.push('authInterceptor');
  }

  AppConfig.$inject = ['$httpProvider', '$locationProvider', 'localStorageServiceProvider'];
  /********** App Run **********/

  function AppRun($rootScope, $window, $location, $cookies, $state, AuthService, LoadingOverlay, MessageController, AUTH_EVENTS, $uibModalStack, AnalyticsService) {
    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
      $uibModalStack.dismissAll();
      LoadingOverlay.hide();

      if (!AuthService.isLoggedIn() && toState.name.indexOf('login') === -1) {
        event.preventDefault();
        var stateData = {};

        if ($location.path() !== '/') {
          stateData = {
            returnto: $location.path()
          };
        }

        MessageController.publish(AUTH_EVENTS.channel, AUTH_EVENTS.requiresLogin);
        $state.go('login', stateData);
      } else if (AuthService.isLoggedIn()) {
        // broadcast that the user is already logged in
        MessageController.publish(AUTH_EVENTS.channel, AUTH_EVENTS.loggedIn);
      }

      $window.scrollTo(0, 0);
    });
    $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
      $rootScope.CURRENT_STATE = toState.name;
      AnalyticsService.pageView($location.$$path);
    }); //GA4 Gtag

    AnalyticsService.getGtag().then(function (response) {
      window.dataLayer = window.dataLayer || [];

      window.gtag = window.gtag || function () {
        window.dataLayer.push(arguments);
      };

      window.gtag('js', new Date());
      window.gtag('config', response.data);
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = '//www.googletagmanager.com/gtag/js?id=' + response.data;
      document.getElementsByTagName('head')[0].appendChild(script);
    }, function (errorResponse) {
      console.log(errorResponse);
    });
  }

  AppRun.$inject = ['$rootScope', '$window', '$location', '$cookies', '$state', 'AuthService', 'LoadingOverlay', 'MessageController', 'AUTH_EVENTS', '$uibModalStack', 'AnalyticsService'];
  angular.module('livestayAPP', ['ngMessages', 'ngSanitize', 'ngCookies', 'ui.router', 'ui.bootstrap', 'LocalStorageModule', 'app.components', 'app.views', 'app.filters', 'app.services', 'app.constants', 'lr.messagecontroller', 'lr.notification-bar', 'auth.interceptor', 'angularLazyImg', 'payment', //http://seandesmond.github.io/angular-payment/
  'lr.component-registry', 'lr.sidebar', 'vcRecaptcha']).config(AppConfig).run(AppRun).component('app', {
    bindings: {},
    controller: AppCtrl,
    templateUrl: 'app.template.html'
  });
})(window.angular);